import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ce4e4b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sider-menu" }
const _hoisted_2 = { class: "menu-header" }
const _hoisted_3 = { class: "menu-btn" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-btn-span" }, "任务列表", -1 /* HOISTED */))
const _hoisted_5 = { class: "menu-btn" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-btn-span" }, "GL Account 数据维护", -1 /* HOISTED */))
const _hoisted_7 = { class: "menu-btn" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-btn-span" }, "Brand Mapping数据维护", -1 /* HOISTED */))
const _hoisted_9 = { class: "menu-btn" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-btn-span" }, "Index数据维护", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["layout-siderbar", $setup.activate === 'data-task-management' ? 'no-border' : ''])
  }, [
    _createCommentVNode(" <div class=\"menu-icon\">\n      <svg class=\"icon top-svg-icon\" aria-hidden=\"true\">\n        <use xlink:href=\"#pai-icon-tongyidaiban\"></use>\n      </svg>\n    </div> "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createCommentVNode(" 任务列表（默认首页） "),
        _createVNode(_component_router_link, {
          to: { path: $setup.indexHtmlPath, query: { cls: 'data-task-management' } }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass([{ 'is-activity': $setup.activate === 'data-task-management' }, "menu-item"]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.activate = 'data-task-management'))
            }, [
              _createElementVNode("span", _hoisted_3, [
                _createVNode($setup["k2Tooltip"], {
                  title: "任务列表",
                  placement: "right"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ], 2 /* CLASS */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["to"]),
        _createCommentVNode(" GL Account 数据维护 "),
        _createVNode(_component_router_link, {
          to: { path: $setup.indexHtmlPath, query: { cls: 'financial-data-maintenance' } }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass([{ 'is-activity': $setup.activate === 'financial-data-maintenance' }, "menu-item"]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.activate = 'financial-data-maintenance'))
            }, [
              _createElementVNode("span", _hoisted_5, [
                _createVNode($setup["k2Tooltip"], {
                  title: "GL Account 数据维护",
                  placement: "right"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ], 2 /* CLASS */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["to"]),
        _createCommentVNode(" Brand Mapping数据维护 "),
        _createVNode(_component_router_link, {
          to: { path: $setup.indexHtmlPath, query: { cls: 'brand-mapping-maintenance' } }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass([{ 'is-activity': $setup.activate === 'brand-mapping-maintenance' }, "menu-item"]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.activate = 'brand-mapping-maintenance'))
            }, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode($setup["k2Tooltip"], {
                  title: "Brand Mapping数据维护",
                  placement: "right"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ], 2 /* CLASS */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["to"]),
        _createCommentVNode(" Index数据维护 "),
        _createVNode(_component_router_link, {
          to: { path: $setup.indexHtmlPath, query: { cls: 'data-maintenance' } }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass([{ 'is-activity': $setup.activate === 'data-maintenance' }, "menu-item"]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.activate = 'data-maintenance'))
            }, [
              _createElementVNode("span", _hoisted_9, [
                _createVNode($setup["k2Tooltip"], {
                  title: "Index数据维护",
                  placement: "right"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ], 2 /* CLASS */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["to"]),
        _createCommentVNode(" 查询流程 "),
        _createCommentVNode(" <div :class=\"{ 'is-activity': activate === 'process-search' }\" class=\"menu-item\" @click=\"activate = 'process-search'\">\n          <span class=\"menu-btn\">\n            <router-link to=\"/process-search\">\n              <span class=\"menu-btn-icon\">\n                <i class=\"paifont pai-chaxunliucheng\"></i>\n              </span>\n              <span class=\"menu-btn-span\">{{ $t('menu.process-search1') }}</span>\n            </router-link>\n          </span>\n        </div> "),
        _createCommentVNode(" 更多 "),
        _createCommentVNode(" <div class=\"menu-item\">\n          <a-popover overlayClassName=\"siderbar-popover\" placement=\"right\">\n            <template #content>\n              代理\n              <div :class=\"{ 'is-activity-po': activate === 'my-agent' }\" class=\"popover-btn\">\n                <router-link to=\"/my-agent\" @click=\"activate = 'my-agent'\">\n                  <i class=\"paifont pai-daili1\"></i>\n                  <span>{{ $t('menu.my-agent1') }}</span>\n                </router-link>\n              </div>\n              反馈\n              <div :class=\"{ 'is-activity-po': activate === 'my-feedback' }\"  class=\"popover-btn\">\n                <router-link to=\"/my-feedback\" @click=\"activate = 'my-feedback'\">\n                  <i class=\"paifont pai-fankui1\"></i>\n                  <span>{{ $t('menu.my-feedback1') }}</span>\n                </router-link>\n              </div>\n              报表\n              <div v-if=\"reportMenuList.length > 0\" :class=\"{ 'is-activity-po': activate === 'report' }\" class=\"popover-btn\">\n                <router-link to=\"/report\" @click=\"activate = 'report'\">\n                  <i class=\"paifont pai-a-baobiaofalse\"></i>\n                  <span>{{ $t('menu.report') }}</span>\n                </router-link>\n              </div>\n            </template>\n            <span class=\"menu-btn\">\n              <a><i class=\"paifont pai-gengduo1\"></i></a>\n            </span>\n            <span>{{ $t('menu.more') }}</span>\n          </a-popover>\n        </div> ")
      ])
    ])
  ], 2 /* CLASS */))
}